import React from 'react';
import PropTypes from 'prop-types';
import { useLanguage } from '../../Services/ContextProvider/LanguageContextProvider';
 
function DeleteModal(props) {
  const { t } = useLanguage();

  if (!props.visibleModal) return null;

  return (
    <div id='deleteModal'> {props.visibleModal &&
      <div className="modal d-flex fade show mainContainer delete-history-modal" id="" role="dialog" style={{ display: "block" }} tabIndex="-1" >
        <div className="modal-dialog" style={{ borderRadius: "10px", minWidth: "100%" }}>
          <div className={`modal-content ${props.fadeClass}`}>
            <div className='modal-content_inner'>
              <div className="modal-header cross">
                <button name="closeButton" type="button" className="closebtn" data-bs-dismiss="modal" aria-label="Close" onClick={props.handleClose}><img src="./static/assets/Close_icon.svg" className="close_icon" /></button>
              </div>
 
              <div className="modal-body">
                <div className='modal-body_title'>
                  <span className='modal-body_headingText'>{t('Are you sure you want to delete the chat?')}</span>
                </div>
 
                <div className='modal-body_suggestedFeedback modal_body_title2 text-center'>
                  <p>{t('By deleting the chat this message will no longer be available to access.')}</p>
                </div>
                <div className="d-flex justify-content-center" style={{ paddingTop: "30px" }}>
                  <button name="deleteChatButton" className='btnChat delete-btn' onClick={props.confirmDelete}>{t('DELETE CHAT')}</button>
                  <button name="cancelButton" className='btnChat cancel-btn' style={{ marginLeft: "10px" }} onClick={props.handleClose}>{t('CANCEL')}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }</div>
  )
}
 
DeleteModal.propTypes = {
  visibleModal: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  confirmDelete: PropTypes.func.isRequired,
  fadeClass: PropTypes.string
};
 
export default DeleteModal;